import { render } from "./PaymentReturn.vue?vue&type=template&id=732f0cdb&scoped=true"
import script from "./PaymentReturn.vue?vue&type=script&lang=js"
export * from "./PaymentReturn.vue?vue&type=script&lang=js"

import "./PaymentReturn.vue?vue&type=style&index=0&id=732f0cdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732f0cdb"]])

export default __exports__